import ToDoList from "./ToDoList";



export default function App() {
  return (
    <ToDoList/>
  );
}
